import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlujSHmes_T8Q6aOrUUpMhRH1rRag7YBg",
  authDomain: "kbtrans-50a3f.firebaseapp.com",
  projectId: "kbtrans-50a3f",
  storageBucket: "kbtrans-50a3f.firebasestorage.app",
  messagingSenderId: "417702565858",
  appId: "1:417702565858:web:8c37578d15130ce48a0bbb",
  measurementId: "G-E2PBTY3VH2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only if supported
let analytics = null;

if (typeof window !== 'undefined') {
  const consentAccepted = () => {
    if (!analytics) {
      isSupported().then((supported) => {
        if (supported) {
          analytics = getAnalytics(app);
          console.log('Firebase Analytics initialized after consent');
        }
      });
    }
  };

  // Initialize immediately only if prior consent stored
  try {
    const stored = localStorage.getItem('consent');
    if (stored === 'accepted') {
      consentAccepted();
    }
  } catch {}

  // Listen for consent acceptance events from the app
  window.addEventListener('consent-choice', (e) => {
    try {
      const detail = (e && e.detail) || {};
      if (detail.choice === 'accepted') {
        consentAccepted();
      }
    } catch {}
  });
}

// Analytics helper functions
export const trackEvent = (eventName, parameters = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  }
};

export const trackPageView = (pageName, pageTitle) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: pageName
    });
  }
};

export const trackFormSubmission = (formName, success = true) => {
  if (analytics) {
    logEvent(analytics, 'form_submit', {
      form_name: formName,
      success: success
    });
  }
};

export const trackServiceClick = (serviceName) => {
  if (analytics) {
    logEvent(analytics, 'service_click', {
      service_name: serviceName
    });
  }
};

export const trackLanguageChange = (language) => {
  if (analytics) {
    logEvent(analytics, 'language_change', {
      language: language
    });
  }
};

export const trackCookieConsent = (consentType) => {
  if (analytics) {
    logEvent(analytics, 'cookie_consent', {
      consent_type: consentType
    });
  }
};

export { analytics };
export default app; 